import Configuration from '../config/configuration';
import axios from 'axios'
 
class FormsService {

    constructor() {
        this.config = new Configuration();
    }

    addFormsService(formData) {
        return axios.post(this.config.apiBaseUrl + 'queryForm', formData);
    }
    contactUs(formData){
        return axios.post(this.config.apiBaseUrl + 'contactus', formData);
    }
}

export default FormsService